module.exports = __webpack_public_path__ + "static/media/educationPlaceholder.9033ae3b.svg";